import { Injectable } from '@angular/core';
import { InsuranceDataModel } from '../../../../models/insurance-data.model';
import { CalculationService } from '../../calculation.service';
import { CalculationStorageService } from '../../../../../shared/services/calculation-storage.service';
import { InsuranceDataInterface } from '../../../api/sections-api/insurance-data.interface';
import { ConfigurationService } from '../../configuration/configuration.service';
import { Dictionary } from '../../../../configuration/dictionary';
import { Dictionaries, UiConfig } from '../../../../configuration/ui-config';
import * as moment from 'moment';
import {addDaysToDate} from '../../../../utils/utils';
import {tomorrowStartOfTheDay} from '../../../../../shared/utils/time-utils';
import {ApplicationStateService} from '../../../../../shared/services/application-state.service';
import {ApplicationStateStorageService} from '../../../../../shared/services/application-state-storage.service';

@Injectable({
  providedIn: 'root'
})
export class InsuranceDataStateService implements InsuranceDataInterface {

  private dictionaries: Dictionaries;

  constructor(private logicService: CalculationService,
              private configuration: ConfigurationService,
              private storage: CalculationStorageService,
              private stateService: ApplicationStateService,
              private stateStorage: ApplicationStateStorageService) {
    this.dictionaries = this.configuration.uiConfig.dictionaries;
  }

  get insuranceData(): InsuranceDataModel {
    return this.logicService.insuranceData;
  }

  get youngestDriverAgeDictionary(): Dictionary {
    if (this.dictionaries) {
      return this.dictionaries[UiConfig.YOUNGEST_DRIVER_AGE];
    }
    return null;
  }

  get youngestDriverAge() {
    const tempDriverAge = [
      { key: 16, label: '16' },
      { key: 17, label: '17' },
      { key: 18, label: '18' },
      { key: 19, label: '19' },
      { key: 20, label: '20' },
      { key: 21, label: '21' },
      { key: 22, label: '22' },
      { key: 23, label: '23' },
      { key: 24, label: '24' },
      { key: 25, label: '25' },
      { key: 26, label: '26 i więcej' }
    ];
    // sort descending
    tempDriverAge.sort((a, b) => (a.key > b.key) ? -1 : 1);
    return tempDriverAge;
  }

  changeYoungestDriverAge(youngestDriverAge: number): void {
    // this.insuranceData.youngestDriverAge = youngestDriverAge;
    // this.storage.updateCalculation();
  }

  changeStartInsuranceDate(startInsuranceDate: Date): void {
    const newDate = new Date();
    const isToday = moment(startInsuranceDate).isBefore(newDate);
    let formattedDate;
    if (isToday) {
      formattedDate = moment(startInsuranceDate);
      formattedDate.set({'hour': newDate.getHours(), 'minute': newDate.getMinutes(), 'second': newDate.getSeconds()});
      startInsuranceDate = formattedDate.toDate();
    }
    this.insuranceData.startInsuranceDate = startInsuranceDate;
    this.storage.updateCalculation();
    this.logicService.startInsuranceDateChange$.emit();
  }

  changeEndInsuranceDate(endInsuranceDate: Date): void {
    this.stateService.state.endInsuranceDate = endInsuranceDate;
    this.stateStorage.updateApplicationState();
    if (moment(endInsuranceDate).isBefore(addDaysToDate(new Date(), 1))) {
      this.insuranceData.startInsuranceDate = new Date(tomorrowStartOfTheDay());
    } else {
      this.insuranceData.startInsuranceDate = addDaysToDate(moment(endInsuranceDate).toDate(), 1);
    }
    this.storage.updateCalculation();
  }
}
